export default function PHP_date_offset_get() {
  return (
    <div>
      <h1>PHP_date_offset_get</h1>
    </div>
  );
}
